import React from "react";
import { useDispatch, useSelector } from "react-redux";
import videoJobIdSelector from "selectors/videoJobId";
import AnimationSection from "./AnimationSection";
import ReviewAnimationVideoJobRouter from "./ReviewAnimationVideoJobRouter";

const ReviewAnimationSection: React.FC = () => {
    const dispatch = useDispatch();
    const videoJobId = useSelector(videoJobIdSelector);

    React.useEffect(() => {
        dispatch({
            type: "com.sage.actions.createAnimation.ISetHasSeenThirdTab",
            hasSeen: true,
        } as sage.actions.createAnimation.ISetHasSeenThirdTab);
    }, [dispatch]);

    React.useEffect(() => {
        if (!videoJobId) {
            dispatch({
                type: "com.sage.actions.createAnimation.ISetTab",
                tab: 1,
            } as sage.actions.createAnimation.ISetTab);
        }
    }, [videoJobId, dispatch]);

    return (
        <AnimationSection
            title="Review Animation"
            description="Review your animation before you go ahead and use it. Use the frame slider at the bottom to check different frames."
        >
            {videoJobId && (
                <ReviewAnimationVideoJobRouter videoJobId={videoJobId} />
            )}
        </AnimationSection>
    );
};

export default ReviewAnimationSection;
